export const playbackSpeedOptions = {
  HOUR: 'HH',
  MONTH: 'MM',
  YEAR: 'YYYY'
};
export const timeUnits = {
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year'
};
export const sliderTypes = {
  YEAR: 'year',
  DATE: 'date'
};